export enum EntityType {
  Compressor = 'Compressor',
  Tool = 'Tool',
  Pump = 'Pump',
}
